import React, { useState, useEffect } from "react";
import apiClient from "./http-common";
import ScriptList from "./components/ScriptList";
import "./App.css";

function makeDataFlat(response) {
  return response.data.result.map((scriptData) => {
    let dataOutput = [];
    const dbArray = ["dev", "qa", "uat", "prod"];
    const statusesFlat = [];

    dbArray.forEach((db) => {
      const foundElement = scriptData.status.find(
        (statusData) => statusData.db === db
      );

      statusesFlat[db] = foundElement.released;
    });

    dataOutput.push({
      script: scriptData.script,
      dev: statusesFlat["dev"],
      qa: statusesFlat["qa"],
      uat: statusesFlat["uat"],
      prod: statusesFlat["prod"],
    });

    return dataOutput;
  });
}

export default function App() {
  const [scripts, setScripts] = useState([]);
  const [sstenv, setSstenv] = useState("");

  const fetchData = async () => {
    const response = await apiClient.get("/getscriptstatuslist");
    const dataFlat = makeDataFlat(response);
    setScripts(dataFlat);
    setSstenv(response.data.sstEnv);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div>
        <h1>Script List</h1>

        <table>
          <tbody>
            <tr>
              <th>Name</th>
              <th>Dev</th>
              <th>QA</th>
              <th>UAT</th>
              <th>Prod</th>
            </tr>
            <ScriptList
              scripts={scripts}
              fetchData={fetchData}
              sstEnv={sstenv}
            />
          </tbody>
        </table>
      </div>
    </>
  );
}
